module.exports = __webpack_public_path__ + "img/shadow-sm-landscape.f02cdc2.png";